'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
/*
 * Convert a CSS time string to integer we can use in JavaScript.
 * The output is in milliseconds as this unit is used in most methods.
 *
 * Example:
 * 0.25s -> 250
 * 250ms -> 250
 *
 * @param {String} value CSS time string.
 *
 * @return {Integer} Converted value in milliseconds.
 */
var CSSTimeToMilliseconds = exports.CSSTimeToMilliseconds = function CSSTimeToMilliseconds(value) {
  var float = Number.parseFloat(value);
  var unit = value.substr(float.toString().length);
  if (unit === 's') {
    return float * 1000;
  }
  // Assume unit is `ms`. In other words, `parseInt()` would equal the result.
  return float;
};

/*
 * @param {Integer} min Inclusive.
 * @param {Integer} max Exclusive.
 */
var getIntegerInRange = exports.getIntegerInRange = function getIntegerInRange(min, max) {
  return Math.random() * (max - min) + min;
};

/*
 * Converts the passed number to a valid CSS string. The number can be both integer or float.
 * We use `px` as the default unit. Additionally, we can pass `auto` instead of a number as
 * that's a valid size value for CSS.
 */
var numberToCSSValue = exports.numberToCSSValue = function numberToCSSValue(value) {
  if (value === 'auto') return value;
  return value + 'px';
};

/*
 * Checks if the given point is inside rectangle.
 */
var pointBelongsToRectangle = exports.pointBelongsToRectangle = function pointBelongsToRectangle(point, rect) {
  var isXWithin = rect.left <= point.x && rect.right >= point.x;
  var isYWithin = rect.top <= point.y && rect.bottom >= point.y;
  return isXWithin && isYWithin;
};

/*
 * Converts a pixel string to integer. Used when we want to work with CSS values.
 *
 * Example: `16px` => 16
 */
var pxToInt = exports.pxToInt = function pxToInt(str) {
  return Number.parseInt(str || 0, 10);
};

var rectanglesIntersect = exports.rectanglesIntersect = function rectanglesIntersect(a, b) {
  return !(a.left > b.right || a.right < b.left || a.top > b.bottom || a.bottom < b.top);
};